<template>
      <el-carousel indicator-position="outside" :autoplay="true"  @change="changeSwiper">
        <!-- <el-carousel-item> -->
          <el-carousel-item v-for="(item, index) in swiperItems" :key="index">
          <div class="index_swiper" :style="{backgroundImage:  item.url ? 'url(' + item.url + ')' : '../../../assets/image/资源 62.png'}">
            <div class="swiper_container">
              <div class="left_image left_layout">
                <div class="layout_con">
                  <img :src="item.icon ? item.icon : '../../../assets/image/12.数字孪生+.png'">
                  <p class="layout_p1 layout_p1_margin">{{ item.left_top ? item.left_top : 'Digital twin + ' }}</p>
                  <p class="layout_p2 layout_p2_margin">{{ item.left_bottom ? item.left_bottom : '数字孪生 + ' }}</p>
                </div>
              </div>
              <div class="right_title">
                <p class="title1 title1_margin">{{ item.title ? item.title : '数字孪生 + ' }}</p>
                <p class="title2 title2_margin">{{ item.content1 ? item.content1 : 'Through virtual simulation and real-time data analysis, the overall optimization and intelligent management of the production process are realized, and the manufacturing efficiency and product quality are greatly improved.' }}</p>
                <p class="title2">{{ item.content2 ? item.content2 : '通过虚拟仿真和实时数据分析，实现园区的智能化管理与优化，提升运营效率和安全性。' }}</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
  </template>

  <script>
import { getBanner } from '../../../util/index'
import { fromDictToArray } from '../../../util/tool.js'
  export default {
    name:'IndexSwiper',
    data() {
      return {
        swiperItems: ['Slide 1', 'Slide 2', 'Slide 3', 'Slide 4', 'Slide 5'],
        swiperInstance: null,
      };
    },
    props:{
      isIndex:Boolean
    },
    mounted() {
      let page = '定制服务', category = '轮播图'
      getBanner(page, category).then(res => {
        if(res.code === 200){
          let data = fromDictToArray(res.data)
          this.swiperItems = data
          this.swiperItems.forEach((item, index) => {
            if(index === 0){
              // 智能制造
              item.url = require('../../../assets/image/3.1-1.png')
              item.icon = require('../../../assets/image/智能制造icon.png')
            }else if(index === 1){
              // 园区
              item.url = require('../../../assets/image/3.1-2.png')
              item.icon = require('../../../assets/image/圆区icon.png')
            }else if(index === 2){
              // 港口
              item.url = require('../../../assets/image/3.1.png')
              item.icon = require('../../../assets/image/港口icon.png')
            }else if(index === 3){
              // 能源
              item.url = require('../../../assets/image/3.1-4.png')
              item.icon = require('../../../assets/image/能源icon.png')
            }
          })
        }
      })
    },
    methods:{
      changeSwiper(index){
      //   let total = this.swiperItems.length
      //   let pagesInfo = {
      //     total,
      //     index: index+1
      //   }
      //   this.$emit('totalPages', pagesInfo)
      }
    },
  };
  </script>

  <style scoped lang="less">
  ::v-deep .el-carousel__container{
    height: 95vh;
  }
  ::v-deep .el-carousel__indicators--outside{
    // display: none;
    position: absolute;
    left: 45%;
  }
  ::v-deep .el-carousel__indicator--horizontal{
    padding: 0.5rem 0.75rem;
  }
  ::v-deep .el-carousel__indicator.is-active button{
    background-color: #54d1ef;
  }
  ::v-deep .el-carousel__button{
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  .el-carousel__item h3 {
    color: #ffffff;
    font-size: 18px;
    opacity: 0.75;
    line-height: 500px;
    margin: 0;
  }
  .index_swiper{
    background-image: url("../../../assets/image/资源 62.png");
    background-size: cover;
    height: 100%;
    display: flex;
    align-items: center;
    // justify-content: center;
  }
  .swiper_container{
    width: 80%;
    display: flex;
    margin: 0 auto;
    padding-bottom: 5rem;
    .left_image, .right_title{
      color: #ffffff;
    }
    .left_layout{
      display: flex;
      width: 50%;
      // margin-right: 5%;
      .layout_con{
        margin-right: 20px;
        width: 100%;
      }
      .layout_p1{
        font-size: 0.75rem;
        color: #999999;
      }
      .layout_p1_margin{
        margin-top: 5%;
        font-family: AliLight;
        color: #969696;
        font-size: 0.9rem;
      }
      .layout_p2{
        font-size: 1rem;
        color: #fff;
        font-family: AliRegular;
      }
      .layout_p2_margin{
        margin-top: 5%;
      }
    }
    .right_title>.title1{
      color: #54ceec;
      font-family: AliBold;
      font-size:3.6rem;
      // letter-spacing: 0.5rem;
      // line-height: 1.1;
    }
    // .right_title>.title1_margin{
    //   margin-top: 5%;
    // }
    .right_title>.title2{
      font-size: 0.9rem;
      color: #dadada;
      letter-spacing: 0.1rem;
      line-height: 1.8;
    }
    .right_title>.title2_margin{
      margin-top: 3%;
      max-width: 90%;
    }
    .right_title>.detail{
      font-size: 0.75rem;
      margin: 6% 0 0 0;
      color: #999999;
      cursor: pointer;
    }
    .right_title>img{
      margin-left: 1%;
    }
  }
  </style>